import React from 'react'

const AvgSessionsIcon = props => (
  <svg width="32" height="34" viewBox="0 0 32 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#000" fill="none" strokeWidth="1.5">
      <rect x="8" y="18" width="3" height="6" rx="1.5" />
      <rect x="14.5" y="14" width="3" height="10" rx="1.5" />
      <rect x="21" y="10" width="3" height="14" rx="1.5" />
    </g>
  </svg>
)

export default AvgSessionsIcon
